import req from './request'

const DEFAULT_ENDPOINTS = {
    telephonys: '/communications/telephony',
    setStatus: '/communications/telephony/set-status',
    listStatus: '/communications/telephony/list-status',
    getStatus: '/communications/telephony/get-status'
}

export default {
    telephonys(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.telephonys, param)
    },
    setStatus(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.setStatus, param)
    },
    listStatus(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.listStatus, param)
    },
    getStatus(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.getStatus, param)
    },
}